/*
  Global unsaved changes tracker.
  - Sets window._hasUnsavedChanges = true when inputs/selects/textareas/contenteditable change
  - Clears flag on form submit
  - Adds a beforeunload handler to show browser prompt when flag is set
  - Exposes helpers: window.markUnsaved(), window.clearUnsaved(), window.hasUnsavedChanges()
*/

(function () {
    if (typeof window === 'undefined') return;

    window._hasUnsavedChanges = false;

    function markUnsaved() {
        window._hasUnsavedChanges = true;
    }

    function clearUnsaved() {
        window._hasUnsavedChanges = false;
    }

    function hasUnsavedChanges() {
        return !!window._hasUnsavedChanges;
    }

    window.markUnsaved = markUnsaved;
    window.clearUnsaved = clearUnsaved;
    window.hasUnsavedChanges = hasUnsavedChanges;

    // Listen for user interactions that indicate change
    function isIgnored(el) {
        try {
            if (!el || !el.closest) return false;
            // If inside a form marked to ignore unsaved checks
            if (el.closest && el.closest('form[data-no-unsaved], form.no-unsaved')) return true;
            // If the element itself has attribute to ignore
            if (el.getAttribute && (el.getAttribute('data-no-unsaved') !== null || el.classList.contains('no-unsaved'))) return true;
        } catch (err) {
            return false;
        }
        return false;
    }

    function onChangeEvent(e) {
        var el = e.target;
        if (!el) return;
        if (isIgnored(el)) return;
        var tag = (el.tagName || '').toLowerCase();

        if (tag === 'input' || tag === 'textarea' || tag === 'select') {
            // Ignore readonly/disabled
            if (el.readOnly || el.disabled) return;
            markUnsaved();
            return;
        }

        if (el.isContentEditable) {
            markUnsaved();
            return;
        }
    }

    // Capture form changes via input/change events
    document.addEventListener('input', onChangeEvent, true);
    document.addEventListener('change', onChangeEvent, true);

    // Clear on any HTML form submit (including JS-triggered submits)
    document.addEventListener('submit', function (e) {
        // If submission is prevented elsewhere, we shouldn't clear
        // but we can't know; assume submit intends to save
        clearUnsaved();
    }, true);

    // Intercept clicks on elements with attribute data-clear-unsaved to allow programmatic clears
    document.addEventListener('click', function (e) {
        var el = e.target;
        while (el && el !== document) {
            if (el.getAttribute && el.getAttribute('data-clear-unsaved') !== null) {
                clearUnsaved();
                break;
            }
            el = el.parentNode;
        }
    }, true);

    // beforeunload handler: modern browsers ignore custom messages
    window.addEventListener('beforeunload', function (e) {
        if (hasUnsavedChanges()) {
            // Standard compliant way to trigger prompt
            e.preventDefault();
            // Chrome requires returnValue to be set
            e.returnValue = '';
            return '';
        }
        // else do nothing
    });

    // For single-page navigation within the app (if using anchors), warn user
    document.addEventListener('click', function (e) {
        if (!hasUnsavedChanges()) return;
        var el = e.target;
        while (el && el !== document) {
            if (el.tagName && el.tagName.toLowerCase() === 'a') {
                var href = el.getAttribute('href');
                // If it's an internal fragment or javascript noop, ignore
                if (!href || href.indexOf('#') === 0 || href.indexOf('javascript:') === 0) return;
                var confirmed = window.confirm('You have unsaved changes. Leave this page and discard changes?');
                if (!confirmed) {
                    e.preventDefault();
                } else {
                    // allow navigation
                    clearUnsaved();
                }
                return;
            }
            el = el.parentNode;
        }
    }, true);

})();
